module.exports = __webpack_public_path__ + "img/elvis-xu.82606aa4.jpg";